import { createContext } from "react";

const UserCreditsContext = createContext({
  refreshCredits: true,
  setRefreshCredits: () => {},
});

export default UserCreditsContext;
